import { render, staticRenderFns } from "./modalMillingsSetting.vue?vue&type=template&id=a374d200&scoped=true&"
import script from "./modalMillingsSetting.vue?vue&type=script&lang=js&"
export * from "./modalMillingsSetting.vue?vue&type=script&lang=js&"
import style0 from "./modalMillingsSetting.vue?vue&type=style&index=0&id=a374d200&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a374d200",
  null
  
)

export default component.exports